import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { ErrorLogService } from './error-log.service';
import { MatDialog, MatPaginatorIntl, MatTableDataSource, MatPaginator } from '@angular/material';
import { ErrorLog } from './error-log';
import { ErrorLogQueryInfo } from './error-log-queryinfo';
import { ErrorlogDialogComponent } from './errorlog-dialog/errorlog-dialog.component';

@Component({
  selector: 'app-error-log',
  templateUrl: './error-log.component.html',
  styleUrls: ['./error-log.component.css']
})
export class ErrorLogComponent implements OnInit {

  selected:any;
  keyword: string = "";
  totalCount: number
  errorLogDBSource = new MatTableDataSource<ErrorLog>();
  displayedColumns = ['level', 'class', 'message', 'time', 'more'];
  ranges: any = {
    '今天': [moment(), moment()],
    '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    '近7日': [moment().subtract(6, 'days'), moment()],
    '近30日': [moment().subtract(29, 'days'), moment()],
    '本月': [moment().startOf('month'), moment().endOf('month')],
    '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }
  errorLog: ErrorLog = new ErrorLog();
  query: ErrorLogQueryInfo = new ErrorLogQueryInfo();
  page = 0
  size = 10

  @ViewChild('paginator') paginator: MatPaginator

  constructor(private errLogSrv: ErrorLogService, private errorDialog: MatDialog,
    private matPaginatorIntl: MatPaginatorIntl) { }

  ngOnInit() {
    this.matPaginatorIntl.itemsPerPageLabel = '每頁筆數：';
    this.matPaginatorIntl.nextPageLabel = '下一頁';
    this.matPaginatorIntl.previousPageLabel = '上一頁';
    this.matPaginatorIntl.firstPageLabel = '第一頁'
    this.matPaginatorIntl.lastPageLabel = '最後一頁'
    this.selected = { startDate: moment().subtract(6, 'days'), endDate: moment() }
    this.refresh();
  }

  refresh(): void {
    if (this.keyword || this.selected) {
      if (this.selected) {
        this.query.startTime = this.selected.startDate._d.getTime()
        this.query.endTime = this.selected.endDate._d.getTime();
      }
      this.query.searchText = this.keyword
      this.errLogSrv.searchErrorLog(this.query, this.page, this.size).subscribe(rep => {
        this.errorLogDBSource.data = rep.body['content']
        this.totalCount = rep.body['totalElements']
      })
    } else {
      this.query.startTime = moment().subtract(7, 'days').toDate().getTime()
      this.query.endTime = moment().toDate().getTime();
      this.errLogSrv.get7DaysErrorLog(this.query, this.page, this.size).subscribe(rep => {
        this.errorLogDBSource.data = rep.body['content']
        this.totalCount = rep.body['totalElements']
      })
    }
  }

  detail(errorLog) {
    this.errorDialog.open(ErrorlogDialogComponent, {
      data: errorLog
    })
  }

  pageChanged(event) {
    this.page = event.pageIndex
    this.size = event.pageSize
    this.refresh()
  }

  search() {
    this.paginator.firstPage();
    this.refresh();
  }

  clear() {
    this.paginator.firstPage();
    this.keyword = ""
    this.selected = { startDate: moment().subtract(6, 'days'), endDate: moment() }
    this.refresh()
  }

}
